import { Clock, Loader2 } from "lucide-react";

export default function ValidationQueueStatus({ isValidating, isQueued, queuePosition }) {
    if (isValidating) {
        return (
            <>
                <Loader2 size={12} className="animate-spin" />
                Validating...
            </>
        );
    }

    if (isQueued) {
        return (
            <>
                <Clock size={12} />
                Queue #{queuePosition}
            </>
        );
    }

    return null;
}
